import {
  GETWORKSPACELIST_SUCCESS,
  GETWORKSPACELIST_FAIL,
  LOGOUT,
} from "../actionTypes";

const initialState = {
  user: null,
  isLoggedIn: false,
  loading: false,
};

const getWorkspaceListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETWORKSPACELIST_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
        loading: false,
      };

    case GETWORKSPACELIST_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        loading: false,
      };
    case LOGOUT:
      return { ...initialState };
    default:
      return state;
  }
};

export default getWorkspaceListReducer;
